spApp.directive('spinnerDirective', [
  () => ({
    restrict: 'E',
    scope: {
      color: '<?'
    },
    templateUrl: '/views/spinner.html' + Config.assetVersion,
  }),
]);
